export default __webpack_public_path__ + "static/media/closeMemo_icon.9822ced4.svg";